import { inject, Injectable, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpService } from './http.service';
import { Observable, tap } from 'rxjs';
import {
  CloseSessionRequest,
  OpenSessionRequest,
  SessionModel,
} from '@models/session/session.model';
import { TerminalService } from './terminal.service';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private readonly sessionsApi = `${environment.caisseApiUrl}/self-pos-terminal-sessions`;
  private readonly httpService = inject(HttpService);
  private readonly terminalService = inject(TerminalService);
  get terminalId(): number | undefined {
    return this.terminalService.currentTerminal()?.id;
  }

  readonly lastSession = signal<SessionModel | null>(null);

  getLastSession(): Observable<SessionModel> {
    return this.httpService
      .get<SessionModel>(`${this.sessionsApi}/last/self-pos-terminal/${this.terminalId}`)
      .pipe(tap((session) => this.lastSession.set(session)));
  }

  openSession(request: OpenSessionRequest): Observable<SessionModel> {
    return this.httpService.post<SessionModel>(this.sessionsApi, request);
  }

  closeSession(request: CloseSessionRequest): Observable<SessionModel> {
    return this.httpService
      .put<SessionModel>(`${this.sessionsApi}`, request)
      .pipe(tap((session) => this.lastSession.set(session)));
  }
}
